module.exports = __webpack_public_path__ + "fonts/99c7b87ad4d3f7ac54a6abfc73bc02e7.txt";